import {Component, OnInit, OnDestroy, AfterViewInit, Input, Pipe, PipeTransform} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { UserModelComponent } from '../models/models.component';
import { SensorModelComponent } from '../models/models.component';
import { SensordataComponent } from '../sensordata/sensordata.component';
import { SharedService } from '../../shared.service';
import { UserPreferenceService } from '../services/user.preferences.service';
import { EcareConfigurationService } from '../services/ecareconfiguration.service';
import { DeviceService } from '../services/device.service';
import { DataStreamService } from '../services/datastream.service';
import { UserService } from '../services/user.service';
import {WebSocketService} from '../websockets/websocket.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {EcareSecurityService} from '../services/ecare_security_service';
import {ToastrService} from 'ngx-toastr';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-live-data',
  templateUrl: './live-data.component.html',
  styleUrls: ['./live-data.component.css']
})

export class LiveDataComponent extends SensordataComponent implements OnInit, AfterViewInit, OnDestroy {
  events = {};
  dataLoaded: boolean = false;
  dataStreamList: any;
  loading = true;
  campaignId: any;
  closeResult: any;
  queryparams: any;
  device: any;
  selectionModel = [];
  allSelected = true;
  streamGroups = {};
  private multipleSignalsForm: any;
  private hideDisabledStreams: boolean;
  private deviceGroup: { categories: {}; device: any };
  private object: any;
  private stompClient: any;
  progressbarValue = 100;
  curSec = 0;
  cprogressbarValue = 0;

  constructor(pagedata: SharedService
  , cookieService: CookieService
  , userPreferences: UserPreferenceService
  , configurationService: EcareConfigurationService
  , dataStreamService: DataStreamService
  , userService: UserService
  , deviceService: DeviceService
  , sharedService: SharedService
  , private modalService: NgbModal
  , private route: ActivatedRoute
  , private router: Router
  , private webSocketService: WebSocketService
  , private securityService: EcareSecurityService
  , private toastr: ToastrService,
              ) {
    super(pagedata, cookieService, userPreferences, configurationService, dataStreamService
    , userService, deviceService, sharedService);
    this.startTimer(12)
     setTimeout(() => { this.loading = false; }, 12000);

    this.queryparams = this.route.queryParams
        .subscribe(params => {
          this.campaignId = params['campaignId'] || '';
          this.deviceId = params['deviceId'] || '';
        });
    this.getADevice(this.deviceId).subscribe(device => {
      this.device = device;
    });
    this.loadData(this.campaignId, this.deviceId);
    //this.stompClient = this.webSocketService.connect('');
    this.object = Object;
  }

  startTimer(seconds: number) {
    const time = seconds;
    const timer$ = interval(1000);

    const sub = timer$.subscribe((sec) => {
      this.cprogressbarValue = this.cprogressbarValue + 8.33
      if (this.curSec === seconds) {
        sub.unsubscribe();
      }
    });
  }

  deviceSelected(event) {
    let params = event.target.value.split(',');
    this.campaignId = params[1];
    this.router.navigate([ '/elasticcare/live-data' ], { queryParams: { campaignId: params[1], deviceId: params[0]} });
  }

  backToDevice() {
    this.router.navigate( [ '/elasticcare/device-view' , {campaignIdParam: this.campaignId}]);
  }

  reorderDeviceList() {
    this.devices.find(x => x.deviceType.deviceManufacturerType === 'EC_DEVICE');
  }

  ngOnInit() {
    setTimeout(() => {
      this.dataStreamList = this.dataStreams;
      console.log('==================== GOT DATASTREAMS ======================= ');
      console.log(this.dataStreams)
      console.log('==================== GOT DATASTREAMS END ======================= ');
    }, 12000);
  }

  ngAfterViewInit(): void {

  }

  /* open a Modal Component from this component and suscribe to select event*/
  initSensorsModal() {
    let hideDisabledStreams = false;
    let hasStreamsToDisplay = true;

    const initialState = {
        streams: this.dataStreams,
        devices: this.devices,
        settings: this.settings,
        categoryLabels: this.labels,
        hideDisabledStreams: false,
        hasStreamsToDisplay: true
    };
    for (let i = 0, len = this.dataStreams.length; i < len; i++) {
      this.selectionModel[this.dataStreams[i].id] = this.settings.export[this.dataStreams[i].id].selected;

      if ((this.hasStreamsToDisplay
          /*&& this.dataStreams[i].enabled === false*/) && (this.device !== null && this.dataStreams[i].deviceId !== this.device.id)) {
        continue; //continue
      }
      this.deviceGroup = this.streamGroups[this.dataStreams[i].deviceId];
      if( !this.deviceGroup ) {
        this.deviceGroup = {
          device: this.resolveDevice(this.dataStreams[i].deviceId),
          categories: {}
        };
        this.streamGroups[this.dataStreams[i].deviceId] = this.deviceGroup;
      }
      const displayCategoryName = this.labels[this.dataStreams[i].dataStreamType.category].defaultValue;
      let categoryGroup = this.deviceGroup.categories[displayCategoryName];
      if (!categoryGroup) {
        categoryGroup = {
          streams: []
        };
        this.deviceGroup.categories[displayCategoryName] = categoryGroup;
      }
      categoryGroup.streams.push(this.dataStreams[i]);
    }
    this.updateSelectAllStreams(true, hideDisabledStreams);
  }

  updateSelectAllStreams(defaultValue, hideDisabledStreams) {
    defaultValue = defaultValue === true || false;
    let checkedFound = false;
    let uncheckedFound = false;

    for (let i = 0; i < this.dataStreams.length; i++) {
      const device = this.resolveDevice(this.dataStreams[i].deviceId);
      if (device.deactivated || (hideDisabledStreams &&
          this.dataStreams[i].enabled === false)) {
        continue;
      }

      let streamId = this.dataStreams[i].id;
      let isChecked = this.selectionModel[streamId];

      checkedFound = checkedFound || isChecked;
      uncheckedFound = uncheckedFound || !isChecked;

      if (checkedFound && uncheckedFound) {
        break;
      }
      //all checked
      if (uncheckedFound === false){
        this.allSelected = true;
        if(this.multipleSignalsForm){
          this.multipleSignalsForm = this.allSelected;
        }

      } else if (checkedFound === false){ // All unchecked
        this.allSelected = false;
        if(this.multipleSignalsForm){
          this.multipleSignalsForm = this.allSelected;
        }

      } else {
        this.allSelected = defaultValue;
      }

    }
  }

  selectAllStreams() {
    this.allSelected = !this.allSelected;
    if (this.multipleSignalsForm){
      this.multipleSignalsForm = this.allSelected;
    }

    for (let i = 0; i < this.dataStreams.length; i++){
      if (this.hideDisabledStreams &&
          this.dataStreams[i].enabled === false){
        continue;
      }

      const streamId = this.dataStreams[i].id;
      this.selectionModel[streamId] = this.allSelected;
    }
  }

  savePreference() {
    let prefs = {};
    console.log(this.settings.chart)
    for (let key in this.selectionModel) {
      let value = this.selectionModel[key];
      this.settings.chart[key].selected = value;
      this.settings.export[key].selected = value;
      prefs['sensorData/chart/' + key + '/display'] = value ? true : false;
    }
    // This is just to trigger a manual change event as changing variables inside object is not considered
    this.settings  = JSON.parse(JSON.stringify(this.settings));

    // @ts-ignore
    this.userPreferences.update(prefs, this.securityService.getUserDetails()).subscribe(
        response => {
          this.userPreferences.get('sensorData/*', this.securityService.getUserDetails())
              .subscribe(result => {
                this.preferences = result;
                this.initChartOrderSettings();
              });
          this.toastr.success('Preferences has been updated!', 'Successful!');
        });
  }

  selectionChanged(selectedId, event) {
    this.selectionModel[selectedId] = event;
  }


  resolveDevice(deviceId){
    return this.devices.find(x => x.id === deviceId);
  }

  ngOnDestroy(){
  }

  open(content) {
    this.initSensorsModal();
    this.modalService.open(content, { size: 'lg', backdrop: 'static' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    this.streamGroups = {};
    if (reason === 'save changes') {
      this.savePreference();
    }
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
}

@Pipe({ name: 'keys',  pure: false })
export class KeysPipe implements PipeTransform {
  transform(value: any, args: any[] = null): any {
    return Object.keys(value)//.map(key => value[key]);
  }
}
